import { Tab, TabList } from '@wartek-id/tabs'
import { Text } from '@wartek-id/text'

interface CustomTabListProps {
  activeTabIndex?: number
  tabs: string[]
  disableInactiveTab?: boolean
}

const CustomTabList = ({
  activeTabIndex,
  tabs,
  disableInactiveTab = false,
}: CustomTabListProps) => {
  return (
    <TabList className="px-8 mt-2" withBorder>
      {tabs.map((tab, i) => (
        <Tab
          key={`tab-${i}`}
          disabled={disableInactiveTab ? activeTabIndex !== i : false}
          className="!p-0"
        >
          <div className="flex items-center justify-center gap-2">
            <div
              className={`flex items-center justify-center rounded-full ${
                activeTabIndex === i ? 'bg-blue-70' : 'border border-gray-20'
              } p-4`}
            >
              <div className="absolute flex">
                <Text
                  variant="body-sm"
                  color={activeTabIndex === i ? 'inverse' : 'disabled'}
                >
                  {i + 1}
                </Text>
              </div>
            </div>
            {tab}
          </div>
        </Tab>
      ))}
    </TabList>
  )
}

export default CustomTabList
